export default "__VITE_ASSET__D4aQHv9J__"